<div>
<div class="container-fluid top-nav">
    <div class="row">
        <div class="col">
            <div class="card border-0">
                <app-customer-control></app-customer-control>
            </div>
        </div>
    </div>
</div>
</div>
<div class="spacer"></div>
